import { UsersApi } from "@/api/users";
import { UpdateTrialPeriodRequest } from "@/api/users/types";
import { QueryKey, ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useUpdateTrialPeriod = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: UpdateTrialPeriodRequest) =>
      UsersApi.updateTrialPeriod(body),
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.USERS],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKey.USER, userId],
      });

      queryClient.invalidateQueries({
        queryKey: [ResourceName.VETTING_USERS],
      });
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
  });

  return {
    updateTrialPeriod: mutate,
    isSetTrialPeriodLoading: isPending,
  };
};
